import React, { FC, useMemo, useState } from 'react'
import { VStack, Image, Text, Center } from '@chakra-ui/react'
import { cardImageMap, Steps } from '../../state/interfaces'
import { DatePicker } from 'antd'
import moment from 'moment'
import { addAnswer, selectScenario, useDispatch, useSelector } from '../../state'
import theme from '../../styles'
import { useTranslation } from 'react-i18next'

export interface InputDatePickerProps {
  placeholder?: string
  onChange?: (values: string[]) => void
  name: string
  grandImage?: string
}

export const InputDatePicker: FC<InputDatePickerProps> = ({ placeholder, onChange, grandImage }) => {
  const { t } = useTranslation()
  const technicianTimeChoices = {
    '7h30-12h': t('common_7h30-12h'),
    '12h-17h': t('common_12h-17h'),
    '17h-20h': t('common_17h-20h'),
  }
  const [dateValue, setDateValue] = useState<moment.Moment | null>(null)
  const [selectedTechnicianTime, setSelectedTechnicianTime] = useState<string>('7h30-12h')
  const image = useMemo(() => (grandImage ? cardImageMap[grandImage] : ''), [grandImage])
  const scenario = useSelector(selectScenario)
  const dispatch = useDispatch()

  // const handleOnClick = () => {
  //   onChange && onChange([''])
  // }

  const handleDateChange = (date: moment.Moment | null) => {
    setDateValue(date)
    onChange && onChange([date?.format('YYYY/MM/DD') || ''])
  }

  const selectDateValue = (date: moment.Moment | null) => {
    setDateValue(date)
  }

  const handleTechnicianTimeChange = (choice: string) => {
    setSelectedTechnicianTime(choice)
  }

  const handleMektelDateSubmit = () => {
    dispatch(addAnswer({ stepId: Steps.TECHNICIAN_TIME, answerIds: [selectedTechnicianTime], hidden: true }))
    onChange && onChange([dateValue?.format('YYYY/MM/DD') || ''])
  }

  return (
    <VStack spacing={4} marginY={8} gridRowGap={4}>
      {scenario?.id === 'lead-internet-mektel' ? (
        <>
          <div onClick={(e) => e.stopPropagation()}>
            <DatePicker
              onChange={selectDateValue}
              format="DD/MM/YYYY"
              size="large"
              style={{ width: 180 }}
              value={dateValue}
              placeholder={placeholder}
              disabledDate={(current) => current && current < moment().startOf('day')}
              inputReadOnly // This will make the input read-only, preventing the native date picker from appearing
            />
          </div>
          <Text fontSize={20} pt={4}>
            {t('technician-time')}
          </Text>
          {Object.entries(technicianTimeChoices).map(([key, value]) => (
            <label
              key={key}
              style={{
                display: 'block',
                width: '100%',
                textAlign: 'left',
                fontSize: 18,
                paddingLeft: '10px',
              }}
            >
              <input
                type="checkbox"
                checked={selectedTechnicianTime === key}
                onChange={() => handleTechnicianTimeChange(key)}
                style={{ marginRight: '10px' }}
              />
              {value}
            </label>
          ))}
          {dateValue && (
            <Center
              as="button"
              type="button"
              onClick={handleMektelDateSubmit}
              layerStyle={theme.LayerStyles.LARGE_PILL}
              bg="brand"
              borderColor="brand"
              color="white"
            >
              {t('common_continue')}
            </Center>
          )}
        </>
      ) : (
        <div onClick={(e) => e.stopPropagation()}>
          <DatePicker
            onChange={handleDateChange}
            format="DD/MM/YYYY"
            size="large"
            value={dateValue}
            placeholder={placeholder}
            disabledDate={(current) => current && current < moment().startOf('day')}
            inputReadOnly // This will make the input read-only, preventing the native date picker from appearing
          />
        </div>
      )}
      {image && <Image src={image} alt="image" width={['0', '250px']} height={['0', '250px']} />}
    </VStack>
  )
}
